// src/core/online_manager.js

const onlineManager = {
    // DOM Elements - Cached for performance
    elements: {},
    intentionalDisconnect: false,

    init: function () {
        console.log("OnlineManager başlatılıyor...");
        this.cacheElements();

        // 1. Modülleri Başlat (Eğer init fonksiyonları varsa)
        if (window.LobbyManager) LobbyManager.init();
        if (window.OnlineGameUI) OnlineGameUI.init();


        // 2. Global Multiplayer Callback'lerini Ayarla
        multiplayer.onStateChange = this.handleStateChange.bind(this);
        multiplayer.onDisconnected = (code) => {
            // Delegasyon: ConnectionHandler
            if (window.ConnectionHandler) {
                ConnectionHandler.handleDisconnect(code, this.intentionalDisconnect);
            }
            // Reset intenional disconnection logic handled inside ConnectionHandler or just reset local flag?
            // Actually handler doesn't modify this flag, we should reset it here if we manage it here.
            if (this.intentionalDisconnect) this.intentionalDisconnect = false;
        };

        // 3. İstatistikleri Başlat
        if (window.StatsManager) {
            StatsManager.startPolling(this.elements.globalPlayerCount);
        }
    },

    updateRoomUI: function (state) {
        // [DEPRECATED] Managed by LobbyManager completely.
        // Keeping empty function just in case legacy calls exist, but it does nothing.
        console.warn("[OnlineManager] updateRoomUI is deprecated. Use LobbyManager.");
    },

    cacheElements: function () {
        this.elements = {
            roomIdDisplay: document.getElementById('display-room-id'),
            globalPlayerCount: document.getElementById('global-player-count')
        };
    },

    // --- FACADE METHODS (Delegasyon) ---

    // State Değişimi: Sunucudan gelen durumu ilgili modüllere dağıt
    handleStateChange: function (state) {
        console.log(`[OnlineManager] State Change: ${state.status}`);
        const mySessionId = multiplayer.room ? multiplayer.room.sessionId : null;

        if (state.status !== "playing") {
            this.hasForcedChatHide = false;
        }

        // 1. Lobi Güncellemeleri (Oyuncu listesi, başlat butonu vs.)
        // 1. Lobi Güncellemeleri (Oyuncu listesi, başlat butonu vs.)
        if (window.LobbyManager) {
            this.isHost = LobbyManager.updatePlayerList(state, mySessionId);

            // [NEW] Update Waiting Room Settings Visibility
            if (state.status === "waiting") {
                LobbyManager.updateWaitingRoomUI(state, this.isHost);
            }

            if (state.status === "waiting") {
                // [FIX] Ensure Winner Overlay is gone
                const winOverlay = document.getElementById('winner-overlay');
                if (winOverlay) winOverlay.remove();

                // Refresh Stats if coming back from game
                if (window.AuthManager) window.AuthManager.fetchProfile();

                const currentScreen = document.querySelector('.screen.active');
                if (currentScreen && (currentScreen.id === 'game-screen' || currentScreen.id === 'result-screen')) {
                    console.log(`[OnlineManager] Status is waiting, but screen is ${currentScreen.id}. Switching back to lobby.`);
                    if (typeof ui !== 'undefined') ui.showScreen('waiting-room-screen');
                }
            }

            // [MUSIC SYNC]
            if (state.music && window.audio) {
                if (this.lastPlayedMusic !== state.music) {
                    window.audio.playMusic(state.music);
                    this.lastPlayedMusic = state.music;
                }
            }
        }



        // 3. Oyun İçi Güncellemeler
        if (state.status === "playing") {
            // Existing Quiz Logic
            if (typeof ui !== 'undefined' && ui.showScreen) {
                ui.showScreen('game-screen', true, true);

                setTimeout(() => {
                    const gs = document.getElementById('game-screen');
                    if (gs && gs.classList.contains('hidden')) {
                        gs.classList.remove('hidden');
                    }
                }, 100);
            }

            const overlay = document.getElementById('start-countdown-overlay');
            if (overlay) overlay.remove();

            if (window.OnlineGameUI) {
                OnlineGameUI.updateGameLoop(state, mySessionId);
            }
        }
        else if (state.status === "voting") {
            if (window.OnlineGameUI) {
                OnlineGameUI.showRouletteVoting(state, mySessionId);
            }
        }
        else if (state.status === "starting") {
            // [FIX] Trigger 3-2-1 Countdown only when requested (Classic mode start or Wheel Mode final phase)
            const shouldShowCountdown = (state.mode !== 'wheel') || (state.isFinalCountdown === true);

            if (window.LobbyManager && shouldShowCountdown) {
                // Ensure we only trigger it once per phase
                if (!this.countdownTriggered) {
                    LobbyManager.showCountdown();
                    this.countdownTriggered = true;
                }
            }
        }
        else if (state.status === "playing") {
            this.countdownTriggered = false;

            // Existing Quiz Logic
            if (typeof ui !== 'undefined' && ui.showScreen) {
                ui.showScreen('game-screen', true, true);

                setTimeout(() => {
                    const gs = document.getElementById('game-screen');
                    if (gs && gs.classList.contains('hidden')) {
                        gs.classList.remove('hidden');
                    }
                }, 100);
            }

            const overlay = document.getElementById('start-countdown-overlay');
            if (overlay) overlay.remove();

            if (window.OnlineGameUI) {
                OnlineGameUI.updateGameLoop(state, mySessionId);
            }
        }
        else if (state.status === "result") {
            if (window.OnlineGameUI) OnlineGameUI.showResult(state, mySessionId);
        }
        else if (state.status === "final_results" || state.status === "finished") {
            if (window.OnlineGameUI) OnlineGameUI.showFinalResults(state);
        }
    },

    // Odaya Katılınca
    onRoomJoined: function (room) {
        console.log("Odaya Katılındı: ", room.roomId);
        if (window.audio && window.audio.playSound) window.audio.playSound('lobby_entry');

        // [FIX] Show Screen FIRST to ensure DOM elements exist
        if (typeof ui !== 'undefined') ui.showScreen('waiting-room-screen');

        // Then cache elements (now they exist)
        this.cacheElements();
        if (window.LobbyManager) LobbyManager.cacheElements();

        // [ROULETTE FIX] CRITICAL: Setup OnlineGameUI Room Listeners
        if (window.OnlineGameUI) {
            OnlineGameUI.setupRoomListeners(room);
        }

        if (this.elements.roomIdDisplay) {
            // [FIX] Prefer showing Room Code if available, fallback to ID
            // Check both state directly and room metadata if available
            const code = (room.state && room.state.roomCode) ? room.state.roomCode : room.roomId;
            this.elements.roomIdDisplay.innerText = code || "-----";

            // [DEBUG] Log
            console.log("Room Code Set:", code);
        } else {
            // Fallback: Try to get element directly if cache failed
            const el = document.getElementById('display-room-id');
            if (el) {
                const code = (room.state && room.state.roomCode) ? room.state.roomCode : room.roomId;
                el.innerText = code;
                this.elements.roomIdDisplay = el;
            }
        }

        // [FIX] Copy Button Listener
        const copyBtn = document.getElementById('copy-room-id-btn');
        if (copyBtn) {
            copyBtn.onclick = () => {
                const code = (room.state && room.state.roomCode) ? room.state.roomCode : room.roomId;
                navigator.clipboard.writeText(code).then(() => {
                    this.showNotification("Oda kodu kopyalandı! 📋");
                    copyBtn.innerHTML = "✅";
                    setTimeout(() => copyBtn.innerHTML = "❐", 2000);
                }).catch(err => {
                    console.error("Copy failed:", err);
                    prompt("Oda Kodu (Kopyala):", code);
                });
            };
        }



        // [DEBUG] Notifications via new Module
        room.onMessage("notification", (data) => {
            if (data && data.message && window.NotificationManager) {
                NotificationManager.show(data.message, data.type || "info");
            }
        });

        // [NEW] Game Reset - Clean up UI
        room.onMessage("resetGame", () => {
            console.log("🔄 Game Reset Message Received");
            if (window.OnlineGameUI && window.OnlineGameUI.reset) {
                window.OnlineGameUI.reset();
            }
            // Ensure we are on the waiting room screen
            if (typeof ui !== 'undefined') ui.showScreen('waiting-room-screen');
        });

        // [ROULETTE FIX] Redirect eliminated players to home page
        room.onMessage("youAreEliminated", (data) => {
            console.log("💀 Eliminated:", data.message);
            this.showNotification(data.message, "error");

            // Wait a moment then leave
            setTimeout(() => {
                this.leaveRoom();
            }, 3000);
        });

        // [NEW] Game Ended - Show Winner with Lobby Return Option
        room.onMessage("gameEnded", (data) => {
            console.log("🏆 Game Ended:", data);

            // Create winner overlay
            const overlay = document.createElement('div');
            overlay.id = 'winner-overlay';
            overlay.style.cssText = `
                position: fixed;
                top: 0; left: 0; right: 0; bottom: 0;
                background: rgba(0,0,0,0.95);
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                z-index: 9999;
                animation: fadeIn 0.5s ease;
            `;

            // Build scoreboard
            let scoreboardHTML = data.players
                .sort((a, b) => b.score - a.score)
                .map((p, i) => {
                    const medal = i === 0 ? '🥇' : (i === 1 ? '🥈' : (i === 2 ? '🥉' : ''));
                    const style = p.isWinner ? 'color: gold; font-weight: bold;' : 'color: #aaa;';
                    return `<div style="${style} padding: 8px; font-size: 1.2rem;">${medal} ${p.name}: ${p.score} puan</div>`;
                })
                .join('');

            overlay.innerHTML = `
                <div style="text-align: center; max-width: 500px; padding: 20px;">
                    <div style="font-size: 4rem; margin-bottom: 10px;">🏆</div>
                    <h1 style="color: gold; font-size: 2.5rem; margin: 0 0 10px;">OYUN BİTTİ!</h1>
                    <h2 style="color: #fff; font-size: 1.8rem; margin: 0 0 30px;">Kazanan: ${data.winner || 'Berabere'}</h2>
                    <div style="background: rgba(255,255,255,0.1); padding: 20px; border-radius: 12px; margin-bottom: 30px;">
                        <h3 style="color: #888; margin: 0 0 15px;">LİDER TABLOSU</h3>
                        ${scoreboardHTML}
                    </div>
                    <div style="display: flex; gap: 15px; justify-content: center; flex-wrap: wrap;">
                        <button id="play-again-btn" style="
                            background: linear-gradient(135deg, #4CAF50, #45a049);
                            color: white;
                            border: none;
                            padding: 15px 30px;
                            font-size: 1.1rem;
                            border-radius: 8px;
                            cursor: pointer;
                            box-shadow: 0 4px 15px rgba(76, 175, 80, 0.4);
                        ">🏠 ANA SAYFAYA DÖN</button>
                        <button id="return-lobby-btn" style="
                            background: linear-gradient(135deg, #f39c12, #e67e22);
                            color: white;
                            border: none;
                            padding: 15px 30px;
                            font-size: 1.1rem;
                            border-radius: 8px;
                            cursor: pointer;
                            box-shadow: 0 4px 15px rgba(243, 156, 18, 0.4);
                        ">🚪 LOBİYE DÖN</button>
                    </div>
                    <p style="color: #666; margin-top: 20px; font-size: 0.9rem;">Oda 10 saniye içinde otomatik olarak sıfırlanacak...</p>
                </div>
            `;

            document.body.appendChild(overlay);

            // Home Button - Leave room and go back home
            document.getElementById('play-again-btn').onclick = () => {
                overlay.remove();
                this.leaveRoom();
            };

            // Return to Lobby Button - Trigger collective return for everyone
            document.getElementById('return-lobby-btn').onclick = () => {
                if (window.LobbyManager && window.LobbyManager.showCustomConfirm) {
                    window.LobbyManager.showCustomConfirm(
                        "Lobiye Dönüş",
                        "Tüm oyuncuların lobiye dönmesini onaylıyor musunuz?",
                        () => {
                            overlay.remove();
                            if (multiplayer.room) {
                                multiplayer.room.send("requestReturnToLobby");
                            }
                        }
                    );
                } else {
                    const confirmed = confirm("Tüm oyuncuların lobiye dönmesini onaylıyor musunuz?");
                    if (confirmed) {
                        overlay.remove();
                        if (multiplayer.room) {
                            multiplayer.room.send("requestReturnToLobby");
                        }
                    }
                }
            };

            // Auto-remove after 15 seconds (extended for user decision time)
            // [MODIFIED] Auto-remove disabled as requested.
            // Overlay will stay until user clicks "Home" or "Lobby".
            /*
            setTimeout(() => {
                if (document.getElementById('winner-overlay')) {
                    overlay.remove();
                }
            }, 15000);
            */
        });



        // [Global Chat Init]
        if (window.ChatManager) {
            window.ChatManager.init(room, { startHidden: true }); // [FIX] Start Hidden by default
            const chatBtn = document.getElementById('header-chat-btn');
            if (chatBtn) {
                chatBtn.style.display = 'flex';
                // [MODIFIED] Ensure onclick works
                chatBtn.onclick = (e) => {
                    e.stopPropagation();
                    if (window.ChatManager) {
                        window.ChatManager.toggleMinimize(false);
                        // Ensure container is visible
                        if (window.ChatManager.container) {
                            window.ChatManager.container.classList.remove('hidden');
                            window.ChatManager.container.style.opacity = '1';
                            window.ChatManager.container.style.pointerEvents = 'all';
                        }
                    }
                };
            }
        }
    },

    // [NEW] Leave Room and go back to Main Page
    leaveRoom: function () {
        console.log("[OnlineManager] leaveRoom called");
        this.intentionalDisconnect = true;

        if (multiplayer.room) {
            multiplayer.room.leave();
        }

        // Hide Chat
        if (window.ChatManager) window.ChatManager.destroy();

        // Clear UI states
        if (window.OnlineGameUI) {
            window.OnlineGameUI.isTyping = false;
            window.OnlineGameUI.lastQuestionText = null;
        }

        // Go to Main Screen
        if (typeof ui !== 'undefined') {
            ui.showScreen('category-screen');
        } else if (window.Router) {
            window.Router.showScreen('category-screen');
        }

        this.showNotification("Ana sayfaya dönüldü! 👋", "info");
    },

    // --- UTILS ---
    // Notification logic moved to NotificationManager.js
    // ErrorOverlay logic moved to ConnectionHandler.js

    // [FACADE RESTORED]
    switchPanel: function (panelName) {
        if (window.LobbyManager) {
            LobbyManager.switchPanel(panelName);
        }
    },

    // [HELPER] Notification Proxy
    showNotification: function (message, type = 'info') {
        if (window.NotificationManager) {
            NotificationManager.show(message, type);
        } else {
            console.warn(`[NOTIFICATION] ${type.toUpperCase()}: ${message}`);
            alert(message); // Fallback
        }
    }
    // Stats polling moved to StatsManager.js
};

window.onlineManager = onlineManager;
